import type { Suggestion } from "src/types/adapters/query.type";
import { SuggestionItem } from "./SuggestionItem";
import { SuggestionListWrapper } from "../SearchResults.styled";

type SuggestionListProps = {
  suggestions: Suggestion[];
};

function SuggestionList({ suggestions }: SuggestionListProps) {
  return (
    <SuggestionListWrapper>
      {suggestions.map((suggestion, idx) => (
        <SuggestionItem
          key={suggestion.id}
          suggestion={suggestion}
          position={idx}
        />
      ))}
    </SuggestionListWrapper>
  );
}

export { SuggestionList };
